import { render, staticRenderFns } from "./RememberStatisticsDashboard.vue?vue&type=template&id=420e4cc0&scoped=true&"
import script from "./RememberStatisticsDashboard.vue?vue&type=script&lang=ts&"
export * from "./RememberStatisticsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./RememberStatisticsDashboard.vue?vue&type=style&index=0&id=420e4cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e4cc0",
  null
  
)

export default component.exports